import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useAvatarsList() {
  // Use toast
  const toast = useToast();

  const refAvatarListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "url", label: "圖片"},
    // { key: "sort_order", label: "排序", sortable: true },
    // { key: "is_active", label: "狀態", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
    { key: "updated_at", label: "更新日期", sortable: true },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refAvatarListTable.value
      ? refAvatarListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refAvatarListTable.value.refresh();
  };

  const avatarsList = ref(null);

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchAvatars = (ctx, callback) => {

    
    store
      .dispatch("app/fetchAvatars", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { user_images, total } = response.data;
        callback(user_images);
        totalRow.value = total;
        avatarsList.value = user_images
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };



  onMounted(() => {
  });

  return {
    fetchAvatars,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    avatarsList,
    refAvatarListTable,
    ability,
    refetchData,
  };
}
